import PromotionInsights from "@/components/promotions/PromotionInsights"

const MarketingReports = () => {
    return <PromotionInsights mode="marketing" />
}

export default MarketingReports
